import { Plus, Trash2, X } from "lucide-react";
import { Field, Lbl, UploadBtn, fileSrc, inp } from "./WpFields";

const TIP = { residenziale: "Residenziale", aziendale: "Aziendale", agricolo: "Agricolo" };
const blank = () => ({ id: Math.random().toString(36).slice(2, 12), titolo: "", comune: "", provincia: "", anno: "", kwp: "", tipologia: "residenziale", prodotti_torri: [], descrizione: "", foto: [] });

function Prodotti({ value, onChange, prodotti, testid }) {
  const add = (s) => s && !value.includes(s) && onChange([...value, s]);
  const byCode = Object.fromEntries(prodotti.map((p) => [p.slug, p.codice]));
  return (
    <div>
      <Lbl>Prodotti Torri usati</Lbl>
      <div className="mb-1.5 flex flex-wrap gap-1.5">
        {value.map((s) => (
          <span key={s} className="inline-flex items-center gap-1 rounded-full bg-[#C17F59]/20 px-2 py-0.5 text-[11px] text-[#E8B48F]">
            {byCode[s] || s}<button type="button" onClick={() => onChange(value.filter((x) => x !== s))}><X className="h-3 w-3" /></button>
          </span>
        ))}
      </div>
      <select className={inp} value="" onChange={(e) => add(e.target.value)} data-testid={testid}>
        <option value="">+ Aggiungi prodotto dal listino…</option>
        {prodotti.filter((p) => !value.includes(p.slug)).map((p) => <option key={p.slug} value={p.slug}>{p.tipologia} · {p.codice}</option>)}
      </select>
    </div>
  );
}

function Item({ r, i, set, del, up, prodotti }) {
  const f = (k) => (v) => set({ ...r, [k]: v });
  const t = `wp-real-${i}`;
  return (
    <div className="space-y-3 rounded-xl border border-neutral-800 p-4" data-testid={t}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-bold uppercase tracking-widest text-[#C17F59]">Realizzazione {i + 1}</span>
        <button type="button" onClick={del} className="text-neutral-500 hover:text-red-400" data-testid={`${t}-delete`}><Trash2 className="h-4 w-4" /></button>
      </div>
      <Field label="Titolo" value={r.titolo} onChange={f("titolo")} testid={`${t}-titolo`} />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
        <div className="col-span-2"><Field label="Comune" value={r.comune} onChange={f("comune")} testid={`${t}-comune`} /></div>
        <Field label="Prov." value={r.provincia} onChange={(v) => f("provincia")(v.toUpperCase().slice(0, 2))} testid={`${t}-provincia`} />
        <Field label="Anno" value={r.anno} onChange={f("anno")} inputMode="numeric" testid={`${t}-anno`} />
        <Field label="kWp" value={r.kwp} onChange={f("kwp")} inputMode="decimal" testid={`${t}-kwp`} />
      </div>
      <div>
        <Lbl>Tipologia</Lbl>
        <div className="flex gap-2">{Object.entries(TIP).map(([k, l]) => (
          <button key={k} type="button" onClick={() => f("tipologia")(k)} data-testid={`${t}-tip-${k}`}
            className={`rounded-full border px-3 py-1 text-xs transition-colors ${r.tipologia === k ? "border-[#C17F59] bg-[#C17F59] text-black" : "border-neutral-700 text-neutral-300"}`}>{l}</button>
        ))}</div>
      </div>
      <Prodotti value={r.prodotti_torri || []} onChange={f("prodotti_torri")} prodotti={prodotti} testid={`${t}-prodotti`} />
      <Field label="Descrizione" area rows={3} value={r.descrizione} onChange={f("descrizione")} testid={`${t}-descrizione`} />
      <div>
        <Lbl hint={`${(r.foto || []).length}/6`}>Foto</Lbl>
        <div className="flex flex-wrap items-center gap-2">
          {(r.foto || []).map((u, j) => (
            <div key={u} className="relative h-16 w-24 overflow-hidden rounded-lg border border-neutral-800">
              <img src={fileSrc(u)} alt="" className="h-full w-full object-cover" />
              <button type="button" onClick={() => f("foto")(r.foto.filter((_, k) => k !== j))} className="absolute right-0.5 top-0.5 rounded-full bg-black/70 p-0.5 text-white" data-testid={`${t}-foto-del-${j}`}><X className="h-3 w-3" /></button>
            </div>
          ))}
          {(r.foto || []).length < 6 && <UploadBtn api={up} onUrl={(u) => f("foto")([...(r.foto || []), u])} label="Foto" testid={`${t}-foto-upload`} />}
        </div>
      </div>
    </div>
  );
}

export default function WpRealizzazioni({ list, onChange, up, prodotti }) {
  return (
    <div className="space-y-3" data-testid="wp-realizzazioni">
      <p className="text-xs text-neutral-400">Da 3 a 9 lavori, ognuno con almeno una foto (massimo 6).</p>
      {list.map((r, i) => <Item key={r.id} r={r} i={i} up={up} prodotti={prodotti} set={(v) => onChange(list.map((x, k) => (k === i ? v : x)))} del={() => onChange(list.filter((_, k) => k !== i))} />)}
      {list.length < 9 && (
        <button type="button" onClick={() => onChange([...list, blank()])} data-testid="wp-real-add"
          className="inline-flex items-center gap-1.5 rounded-full border border-dashed border-neutral-600 px-4 py-2 text-xs font-semibold text-neutral-300 transition-colors hover:border-[#C17F59]">
          <Plus className="h-4 w-4" />Aggiungi realizzazione ({list.length}/9)
        </button>
      )}
    </div>
  );
}
